import { Flex, notification } from "@payping/web-components";
import { useAsync, useAsyncFn } from "react-use";
import { userApis } from "@payping/api";
import { useEffect } from "react";
import { readAllMessages } from "@payping/redux/actions";
import { useAppDispatch } from "@/utils";

const UnreadMessageNotification = () => {
  const [notify, contextHolder] = notification.useNotification({ top: 100, duration: 0 });

  const { value: data } = useAsync(() => userApis.messageWithOffsetWithLimitWithCancellationTokenGet(0, 1), []);

  const dispatch = useAppDispatch();
  const [, handleSeen] = useAsyncFn(() => dispatch(readAllMessages()), []);
  const hasUnseenMessage = data?.messages?.length ? !data.messages[0].isSeen : false;
  const messageToShow = hasUnseenMessage ? data?.messages?.[0] : "";

  useEffect(() => {
    if (messageToShow) {
      notify.info({
        onClose: () => {
          handleSeen();
        },
        message: messageToShow.title,
        description: (
          <Flex vertical>
            {messageToShow.description}
            <a href={messageToShow.link} target="_blank" rel="noreferrer">
              {messageToShow.link}
            </a>
          </Flex>
        ),
      });
    }
  }, [messageToShow, notification]);

  return contextHolder;
};

export default UnreadMessageNotification;
